module.exports = __webpack_public_path__ + "assets/img/UnavailableCouponMark.c4fd2ee0.png";